import Controller from '../../classes/controller';

export default class controllerExample extends Controller {

	constructor(args) {
		super(args);
	}

	getConfig() {
		return {
			seed: 48241, // 'random' or 0-65535,
			palette: {
				black: 0x000000,
				bg: 0x2f3031,
				green: 0x00bb55,
				magenta: 0xbb00cc,
				red: 0xcc0022,
				yellow: 0xcc7700,
				blue: 0x0055ee,
				white: 0x8888aa,
			},
			viewport: {
				minWidth: 600,
				maxWidth: 800,
				minHeight: 600,
				maxHeight: 800,
			},
			display: {
				// vector shaders
				saturation: 0,
				exposure: 1.3,
				beamFocus: 0.4,
				aberration: 0.5,
				astigmatism: 0.25,
				glowRadius: 128,
				glowIterations: 27,
				noise: 0,
				contrast: 4.7,
				antialiasing: 0,
				// vector beam
				accuracy: 0,
				voltageSlop: 0.025,
				tracers:0.0,
				beamWidth: 1,
				lfoMult: 4.8,
				// engine
				maxFPS: 60,
				timewarp: 1,
				culling: 0,
			}
		}
	}

	// custom game properties
	score = 0;
	hiscore = 0;

	init() {
		this.system.sceneManager.changeScene('sceneExample');
		// this.system.sceneManager.changeScene('sceneInterfaceDemo');
	}

	reset() {
		this.score = 0;
	}

	update(delta, deltaNormal) {
		// per-frame updates
	}

	points(p) {
		this.score += p;
		if(this.score > this.hiscore) this.hiscore = this.score;
	}

}